"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.Picture = exports.Box = exports.StyledFeatures = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
exports.StyledFeatures = styled_components_1.default.div `
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;

	${(0, styled_breakpoints_1.up)('md')} {
		justify-content: initial;
	}
`;
exports.Box = styled_components_1.default.div `
	width: 100%;
	padding: 0 2em 3em;
	display: flex;
	position: relative;
	flex-direction: column;

	${(0, styled_breakpoints_1.up)('sm')} {
		width: 50%;
	}

	${(0, styled_breakpoints_1.up)('md')} {
		width: 33%;
	}
`;
exports.Picture = styled_components_1.default.div `
	width: 150px;
	height: 150px;
	overflow: hidden;
	align-self: center;
	& img {
		display: block;
		max-width: 100%;
	}
`;
exports.Content = styled_components_1.default.dl `
	align-self: center;
	flex: 1;
	text-align: center;

	dt {
		color: ${props => props.theme.color.brand2};
		font-size: 1.2em;
		font-weight: 700;
		margin: 0 0 0.5em;
	}
`;
